/**
 * アプリケーション共通定数
 *
 * タイムアウト、ポーリング間隔、制限値などのMagic Numbersを一元管理
 */

// ============================
// ポーリング関連
// ============================

/**
 * ログ一覧のポーリング間隔（ミリ秒）
 * 処理中のログがある場合に自動更新する間隔
 */
export const POLLING_INTERVAL_MS = 3000;

// ============================
// セッション関連
// ============================

/**
 * AIアシスタントのセッションタイムアウト（ミリ秒）
 * 30分間操作がない場合、新しいセッションを開始
 */
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30分

// ============================
// コンテンツ制限
// ============================

/**
 * ページコンテンツの最大文字数
 * AIへのトークン送信量を抑制するための制限
 */
export const MAX_PAGE_CONTENT_LENGTH = 5000;

// ============================
// ページネーション
// ============================

/**
 * 一覧表示のデフォルトページサイズ
 */
export const DEFAULT_PAGE_SIZE = 20;

/**
 * 一覧表示の最大ページサイズ
 */
export const MAX_PAGE_SIZE = 100;
